// Api calls for use by Vuex
import AuthWrapper from '@/services/authWrapper';
import store from '@/store/index.js';

class SearchApiService {
  async search (searchReq) {
    var body = {
      command: 'Search',
      search: {
        agencyId: parseInt(store.getters['auth/userProfile'].agencyId),
        maxRows: 50,
        credentials: {
          type: 'AgencyInitials',
          user: store.getters['auth/userProfile'].initials
        },
        includeSummary: true,
        includeDetail: true,
        fields: searchReq.searchFields,
        existence: searchReq.searchArchived ? 'Archived' : 'Active',
        log: true
      }
    };

    var searchUrl = store.getters['auth/resourceEndpoint']('Search');
    if (searchUrl === null) {
      store.dispatch('setError', 'Search API Url was not found.', { root: true });
      return;
    }

    const response = await AuthWrapper.post(searchUrl, body);
    if ((response || null) == null) {
      // eslint-disable-next-line no-console
      console.log('An error occurred performing search. No response.');
      return {
        code: 99,
        message: 'Unable to get search results.'
      };
    }

    if (response.Code === 200) {
      if ((response.Search || null) !== null && response.Search.length > 0) {
        var s = response.Search[0];

        return {
          code: 0,
          data: [{
            count: s.Count,
            more: s.More,
            results: s.Results
          }]
        };
      } else {
        // eslint-disable-next-line no-console
        console.log(`An error occurred performing search: Reason Code: ${response.Reason}`);
        return {
          code: 99,
          message: `Unable to get search results. Reason: ${response.Reason}`
        };
      }
    }

    return response;
  }
}

var x = new SearchApiService();
export default x;
